<template>
  <div class="container">
    <div class="page">
      <div class="header_nav">
        <div>合作厂商一</div>
        <div>
          <router-link class="router_link" to="/Home/MT">合作厂商二</router-link>
        </div>
      </div>
      <div class="partner_img">
        <div class="img">
          <img src="../assets/images/nb/1.png">
        </div>
        <div class="img">
          <img src="../assets/images/nb/2.png">
        </div>
        <div class="img">
          <img src="../assets/images/nb/3.png">
        </div>
      </div>
      <div class="section">
        <div>
          <div class="title">简介
            <div></div>
          </div>
          <div class="intro">
            多名来自硅谷，博世，联电科研人员开始创业，2019年正式成立某新能源科技有限公司。公司依托北京理工大学产业孵化基地，专注汽车电子控制器开发，主要产品包括电摩BMS管理系统，自适应悬架及空气悬架集成系统——ECAS6.0，VCU及BMS集成系统——VBU8.0，电机控制器MCU6.0，满足市场主流AUTOSAR及功能安全ISO26262。
          </div>
        </div>
        <div>
          <div class="title">核心团队
            <div></div>
          </div>
          <div class="team">
            某新能源科技有限公司团队成员来自清华大学、复旦大学、北京理工大学、上海交通大学等学校的硕士，经验丰富、均在大型企业参与并主导过NextEV、吉利、北汽等多款新能源车型。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  }
}
</script>

<style scoped>
/* 二级导航栏 */
.header_nav>div:first-child {
  background:rgba(0,0,0,1);
  color: #fff;
}
.header_nav>div:nth-child(2):hover {
  color: #a3a3a3;
  cursor: pointer;
}
/* 简介 */
/* 核心团队 */
.section .team {
  text-align: left;
  font-size: 14px;
  font-weight:400;
  color:rgba(112,112,112,1);
  line-height:32px;
}
</style>